import { DataTable } from "primereact/datatable";
import React from "react";
import PrimeTableFooter from "../../../components/PrimeTableFooter";
import { Column } from "primereact/column";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CoefficientTable = ({ rows, btnReadMore, bringIn, searchCoefficientId, applyFlag }) => {
  const { t } = useTranslation();

  const actionBodyTemplate = (data) => {
    return (
      <Button
        rounded
        text
        severity="secondary"
        className="p-button-icon-only"
        tooltipOptions={{ position: "top" }}
        tooltip={t("button.apply")}
        onClick={() => {
          bringIn(data);
        }}
      >
        <FontAwesomeIcon icon="fa-solid fa-check" />
      </Button>
    );
  };

  return (
    <>
      <DataTable
        stripedRows
        className="coefficient-table hover-highlight no-shadow"
        tableStyle={{ minWidth: "55rem" }}
        value={rows}
        emptyMessage={t("no_rec")}
        footer={rows?.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={true} btnReadMore={btnReadMore} />}
      >
        <Column
          body={(rowData, columnProps) => {
            return (
              <span
                className="link"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  searchCoefficientId(rowData);
                }}
              >
                {rowData?.coefficientName}
              </span>
            );
          }}
          field="coefficientName"
          header={t("carbonCoefficientName")}
        />
        <Column field="carbonFootprintValue" header={t("carbonFootprintValue")} />
        <Column field="carbonFfootprintUnit" header={t("unit")} />
        <Column field="declareUnitName" header={t("declareUnit")} />
        <Column field="announcementYear" header={t("announcementYear")} />
        {applyFlag && <Column style={{ width: "auto" }} body={actionBodyTemplate} header={t("action")} />}
      </DataTable>
    </>
  );
};

export default CoefficientTable;
